import { createRouter } from "@/router";
// components
import { RouterProvider } from "react-router-dom";
import { AuthProvider, MessageProvider } from "@/providers";
import { useAuth } from "@/contexts";

function AppContent() {
  const auth = useAuth();

  return (
    <RouterProvider
      router={createRouter(!!auth.isOperator)}
      fallbackElement={<p>Loading...</p>}
    />
  );
}

function App() {
  return (
    <AuthProvider>
      <MessageProvider>
        <AppContent />
      </MessageProvider>
    </AuthProvider>
  );
}

export default App;
